import React, { useState } from "react";
import "./confirmEmailClient.css";
import ConfirmEmailImg from "../assets/confirmEmail.png";
import { useNavigate } from "react-router-dom";
import { supabase } from "../../supabaseClient"; // Adjust the import path as needed

export default function ConfirmEmailClient() {
  const navigate = useNavigate();

  const handleContinue = async () => {
    const {
      data: { user },
      error,
    } = await supabase.auth.getUser();
    if (error || !user) {
      alert("Unable to get user info.");
      return;
    }

    // If email_confirmed_at is null, they haven’t clicked the link yet
    if (!user.email_confirmed_at) {
      alert("Please verify your email before continuing.");
      return;
    }

    // Now that we know their email is confirmed, go ahead
    navigate("/createuser/details");
  };
  return (
    <div>
      <div className="confirm-email-container">
        {/* Main content area */}
        <div className="main-content" style={{ flexDirection: "column" }}>
          <div className="card-confirm-email">
            <div className="icon-wrapper">
              <img
                src={ConfirmEmailImg}
                alt="Confirm Email Icon"
                className="confirm-email-img"
              />

              {/* Heading */}
              <h2 className="email-title">Confirm your email address</h2>
              <p className="email-content">
                We sent a link to your email address.
              </p>
              <p className="email-content">
                Click on the link to confirm your email address.
              </p>
              <hr style={{ width: "280px", background: "#E2E2E2" }} />
              <div style={{ marginTop: "20px" }}>
                <p className="email-content">
                  Didn’t get an email?
                  <span>Resend</span>
                </p>
              </div>
            </div>
          </div>
          <div style={{ height: "3rem" }} />
          <button
            type="button"
            className="continue-btn-email"
            onClick={handleContinue}
            style={{ width: "380px" }}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}
